// Shared conversion-tracking helpers for Google Ads (gtag.js) and Meta Pixel (fbq.js).
// Both base tags are already installed once in public/index.html.
// Do NOT reinstall/duplicate them here - only fire event-level conversions.

export const trackWhatsAppClickConversion = () => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "conversion", {
      send_to: "AW-18275777371/UiMoCUa6zNccENv2yIpE",
      value: 1.0,
      currency: "MXN",
    });
  }
  if (typeof window.fbq === "function") {
    window.fbq("track", "Contact");
  }
};
